import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

import { riskLevelLabel } from '@/const/label'

import { Badge, BadgeProps } from '@/components/lemmala-design-system/badge/badge'
import { RISK_LEVEL_MAP } from '@/components/shared/risk-badge/consts'

type AlertSeverityBadgeProps = {
  level: RiskLevel
  showIcon?: boolean
} & BadgeProps

export const AlertSeverityBadge = ({ level, showIcon, ...props }: AlertSeverityBadgeProps) => {
  const label = riskLevelLabel[level]
  const levelConfig = RISK_LEVEL_MAP[level]

  if (!levelConfig) {
    return null
  }

  const { variant, icon: Icon } = levelConfig

  return (
    <Badge
      variant={variant}
      badgeStyle='subtle'
      size='default'
      aria-label={`${label} risk`}
      {...props}
    >
      {showIcon && <Icon className='mr-1 size-4' />}
      {label}
    </Badge>
  )
}
